import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import IModoCompactoConfig from 'Models/docas/IModoCompactoConfig'
import ApiService from 'Services/ApiService'
import {
  ServiceCreateResponse,
  ServiceListResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'

const modoCompacto = {
  verificaSeAtivo: async (idComponente: number): Promise<boolean> => {
    const result: AxiosResponse<IModoCompactoConfig> = await ApiService({
      idComponente,
    }).get<IModoCompactoConfig>(`${hosts.WS_DOCAS}/configuracao_modo_compacto`)

    return result.data?.ativo
  },

  ativaOuDesativa: async (
    idComponente: number,
  ): Promise<AxiosResponse<ServiceCreateResponse>> => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).post<ServiceCreateResponse>(
      `${hosts.WS_DOCAS}/configuracao_modo_compacto`,
    )

    return result
  },
}

export default modoCompacto
